/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from rtu-ui-v2/schemas/creditcard/CreditCardScannerUIResult.yaml
import { ToJsonConfiguration } from '../../common/JsonSerializationTypes';
import { GenericDocument } from '../../generic_document/GenericDocument';
/**
Configuration of the credit card scanner RTU UI result.
*/
export class CreditCardScannerUiResult {
    /** @param source {@displayType `DeepPartial<CreditCardScannerUiResult>`} */
    constructor(source = {}) {
        this._released = false;
        if (source.recognitionStatus !== undefined) {
            this.recognitionStatus = source.recognitionStatus;
        }
        else {
            throw new Error('recognitionStatus must be present in constructor argument');
        }
        if (source.creditCard !== undefined) {
            this.creditCard = source.creditCard != null ? new GenericDocument(source.creditCard) : null;
        }
        else {
            throw new Error('creditCard must be present in constructor argument');
        }
    }
    async serialize(config = new ToJsonConfiguration()) {
        return {
            recognitionStatus: this.recognitionStatus,
            creditCard: this.creditCard != null ? await this.creditCard.serialize(config) : null,
        };
    }
    release() {
        if (this._released) {
            return;
        }
        {
            if (this.creditCard != null) {
                this.creditCard.release();
            }
        }
        this._released = true;
    }
    async encodeImages() {
        if (this.creditCard != null) {
            await this.creditCard.encodeImages();
        }
    }
}
//# sourceMappingURL=CreditCardScannerUiResult.js.map